t = require('app/scripts/views/internal/teacup-with-helpers')('popover_board_header_all_members')
_ = require 'underscore'

module.exports = t.renderable (data, visibleMembers) ->
  memberSections = [
    { key: "members", jsClass: 'js-list-members' }
    { key: "team-members", jsClass: 'js-list-team-members' }
    { key: "recently-joined", jsClass: 'js-list-recently-joined-members' }
    { key: "invited", jsClass: 'js-list-invited-members' }
    { key: "guests", jsClass: 'js-list-guests' }
    { key: "observers", jsClass: 'js-list-observers' }
    { key: "deactivated", jsClass: 'js-deactivated-members' }
  ]

  t.div '.board-header-popover.js-all-members', ->
    t.div '.org-members-actions-search'
    t.input '.board-members-search.js-search-board-member.js-autofocus.js-heading', {
      type: 'text',
      placeholder: t.l('search-board-members')
    }

  t.div '.board-header-popover.js-all-members', ->
    for { key, jsClass } in memberSections
      t.div ".board-menu-member-section.#{ jsClass }", ->
        t.div '.board-menu-member-section-header.js-heading', ->
          t.format key

        t.div '.u-clearfix.js-list', { class: t.classify('js-list-draggable-board-members': data.canAssign) }

  t.div '.js-invite-no-results.hide', ->
    t.p '.board-member-no-results.empty', ->
      if !visibleMembers
        t.format 'not-a-member'
        t.a '.invite-to-board-link.js-invite-to-board-link', { href: '#', target: '_blank' }, ->
          t.format 'invite-to-board'
      else
        t.format 'no-results'